import { ListItemText, ListItemTextProps } from '@mui/material';

export type LegendListItemTextProps = Omit<ListItemTextProps, 'variant'> & {
  variant?: 'watchduty-legend';
};

const mergeLegendRootSlotProps = (
  variant: LegendListItemTextProps['variant'],
  slotProps: ListItemTextProps['slotProps'],
): ListItemTextProps['slotProps'] => {
  if (variant !== 'watchduty-legend') {
    return slotProps;
  }

  const legendRootProps = {
    'data-variant': 'watchduty-legend',
  } as ListItemTextProps['slotProps'] extends infer S
    ? S extends { root?: infer R }
      ? R
      : never
    : never;

  if (!slotProps?.root) {
    return { ...slotProps, root: legendRootProps };
  }

  if (typeof slotProps.root === 'function') {
    const rootSlotProps = slotProps.root;
    return {
      ...slotProps,
      root: (ownerState) => ({
        ...rootSlotProps(ownerState),
        ...legendRootProps,
      }),
    };
  }

  return {
    ...slotProps,
    root: { ...slotProps.root, ...legendRootProps },
  };
};

export const LegendListItemText = (
  props: LegendListItemTextProps,
): JSX.Element => {
  const { variant, slotProps, ...rest } = props;

  return (
    <ListItemText
      {...rest}
      slotProps={mergeLegendRootSlotProps(variant, slotProps)}
    />
  );
};
